module.exports = __webpack_public_path__ + "static/media/landscape.ef9765c3.svg";